module.exports = __webpack_public_path__ + "img/mostlycloudy.66cc3aa7.png";